import api from "api/api";

export const searchStaffQuery = async ({ val, userScope }) =>
  await api.get(
    `/directory/search/staff?field=profile&value=${val}&scope=${userScope}`
  );

export const getStaffByIdQuery = async ({ id, userScope }) =>
  await api.get(`/directory/staff/${id}?scope=${userScope}`);

export const getStaffByArrayIdQuery = async ({ ids, userScope }) =>
  await api.get(`/directory/staff/ids/${ids}?scope=${userScope}`);

export const createStaffQuery = async ({ data }) =>
  await api.post(`/directory/staff`, data);

export const updateStaffQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/staff/${id}?scope=${userScope}`, data);

export const deleteStaffQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/staff/${id}?scope=${userScope}`);

export const getStaffBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/directory/staff/slug/${slug}?scope=${userScope}`);

export const getStaffFourYearsReviewQuery = async ({ id, userScope }) =>
  await api.get(
    `/directory/staff/document/four_years_professional_review/${id}?scope=${userScope}`
  );

export const getStaffByRoleQuery = async ({ role, userScope }) =>
  await api.get(
    `/directory/search/staff?field=role&value=${role}&scope=${userScope}`
  );

export const getStaffByRoleAndNameQuery = async ({
  role,
  search,
  userScope,
}) => {
  if (search.length > 2)
    return await api.get(
      `/directory/search/staff/custom?name=${search}&role=${role}&scope=${userScope}`
    );
  return [];
};
